import { adminNav, adminRoutes } from '@ircf/config';
import { useSession } from '../app/session.js';
import { AppShell, useUnreadCounts } from './AppShell.js';

/**
 * Trainer shell. One person runs coaching and administration from this workspace.
 */
export function AdminLayout() {
  const { role } = useSession();
  const { data } = useUnreadCounts();

  const nav = adminNav.filter((route) => (role ? route.roles.includes(role) : false));

  return (
    <AppShell
      variant="trainer"
      nav={nav}
      areaLabel="Trainer"
      notificationsPath={adminRoutes.notifications.path}
      settingsPath={adminRoutes.settings.path}
      badges={{
        clients: data?.clientsAwaitingApproval ?? 0,
        bookings: data?.bookingRequests ?? 0,
        messages: data?.messages ?? 0,
        notifications: (data?.notifications ?? 0) + (data?.unreadMail ?? 0),
        'check-ins': data?.checkInsAwaitingReview ?? 0,
        feedback: data?.feedbackRequiringAction ?? 0,
        forms: data?.formsAwaitingReview ?? 0,
      }}
    />
  );
}
